// extracted by mini-css-extract-plugin
module.exports =  {"suffix":"gwBxqwSgoHljSb44w_mz"};